import React from 'react'
import _ from 'lodash'
import Button from '@mui/material/Button'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { TextField } from '@mui/material'
import { withTranslation } from 'react-i18next'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import DeleteDialog from '../../DeleteDialog'
import 'react-block-ui/style.css'
import { authContext } from '../../../contexts/AuthContext'
import CPDeleteIconButton from '../../Utils/CPDeleteIconButton'
import CPEditIconButton from '../../Utils/CPEditIconButton'
import { apiUrl } from '../../../config/api'

class ADUserListItem extends React.Component {
  // Fila de lista de usuario interno AAD

  constructor() {
    super()

    this.state = {
      edit: {},
      delete: {}
    }
  }

  static contextType = authContext

  handleEditOpen = (user) => {
    this.setState({
      edit: user
    })
  }

  handleEditClose = () => {
    this.setState({
      edit: {}
    })
  }

  handleDeleteOpen = (user) => {
    this.setState({
      delete: user
    })
  }

  handleDialogClose = () => {
    this.setState({
      edit: {},
      delete: {}
    })
  }

  handleEditUserTypeChange = (event) => {
    let modified = this.state.edit
    modified.type = event.target.value
    this.setState({
      edit: modified
    })
  }

  handleEditRoleChange = (event) => {
    let modified = this.state.edit
    modified.role = event.target.value
    this.setState({
      edit: modified
    })
  }

  update = (user) => {
    user.first_name = document.getElementById('edit_firstName').value
    user.last_name = document.getElementById('edit_lastName').value
    user.email = document.getElementById('edit_email').value
    user.phone = document.getElementById('edit_phone').value
    user.mobile = document.getElementById('edit_mobile').value
    user.loggedUserId = this.context.auth.user.id
    user.brandLabel = window.$brand

    let url = apiUrl('UpdateADUser')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(user)
    })
      .then((res) => console.log(res))
      .then((success) => {
        console.log('Update successful')
      })
      .catch((error) => console.log(error))

    this.handleEditClose()
  }

  delete = (user) => {
    user.loggedUserId = this.context.auth.user.id
    user.brandLabel = window.$brand

    let url = apiUrl('DeleteUser')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(user)
    })
      .then((res) => console.log(res))
      .then((success) => {
        console.log('Delete successful')
      })
      .catch((error) => console.log(error))

    this.props.cardDeleteHandler(user)
  }

  render() {
    const { t, user } = this.props

    return (
      <ListItem
        divider
        secondaryAction={
          this.context.auth.user.email !== user.email && (
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <CPEditIconButton onClick={() => this.handleEditOpen(user)} />
              <CPDeleteIconButton
                onClick={() => this.handleDeleteOpen(user)}
              />
            </Box>
          )
        }
      >
        <ListItemText
          primary={`${user.first_name} ${user.last_name}`}
          secondary={`${user.email}${user.role ? ` — ${t(user.role)}` : ''}`}
        />

        <DeleteDialog
          item={this.state.delete}
          title={t('delete_user')}
          caption={t('delete_user_caption')}
          targetFunc={this.delete}
          handleDialogClose={this.handleDialogClose}
        />
        <Dialog
          open={!_.isEmpty(this.state.edit)}
          onClose={this.handleEditClose}
        >
          <DialogTitle>{t('edit_user')}</DialogTitle>
          <DialogContent>
            <TextField
              required
              id='edit_firstName'
              label={t('Name')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.first_name}
              inputProps={{ maxLength: 20 }}
            />
            <TextField
              required
              id='edit_lastName'
              label={t('Last_name')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.last_name}
              inputProps={{ maxLength: 20 }}
            />
            <TextField
              required
              disabled
              id='edit_email'
              label={t('Email')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.email}
              inputProps={{ maxLength: 50 }}
            />
            <TextField
              id='edit_phone'
              label={t('Phone')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.phone}
              inputProps={{ maxLength: 20 }}
            />
            <TextField
              id='edit_mobile'
              label={t('Mobile')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.mobile}
              inputProps={{ maxLength: 20 }}
              sx={{ pb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel id='edit_type_label'>{t('User_type')}</InputLabel>
              <Select
                labelId='edit_type_label'
                id='edit_type'
                label={t('User_type')}
                onChange={this.handleEditUserTypeChange}
                defaultValue={this.state.edit.type}
              >
                {(this.state.edit.type === 'blp_admin' ||
                  this.state.edit.type === 'blp_user') && [
                  <MenuItem value='blp_admin'>{t('Administrator')}</MenuItem>,
                  <MenuItem value='blp_user'>
                    {window.$brand + ' ' + t('User')}
                  </MenuItem>
                ]}
                {this.state.edit.type === 'admin_zapotal' && (
                  <MenuItem value='admin_zapotal'>Admin Zapotal</MenuItem>
                )}
                {this.state.edit.type === 'external_admin' && (
                  <MenuItem value='external_admin'>
                    {t('External Admin')}
                  </MenuItem>
                )}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id='edit_role_label'>{t('Role')}</InputLabel>
              <Select
                labelId='edit_role_label'
                id='edit_role'
                label={t('Role')}
                onChange={this.handleEditRoleChange}
                defaultValue={this.state.edit.role}
              >
                <MenuItem value={'Associate'}>{t('Associate')}</MenuItem>
                <MenuItem value={'Partner'}>{t('Partner')}</MenuItem>
                <MenuItem value={'Director'}>{t('Director')}</MenuItem>
                <MenuItem value={'Senior Associate'}>
                  {t('Senior Associate')}
                </MenuItem>
                <MenuItem value={'Special Counsel'}>
                  {t('Special Counsel')}
                </MenuItem>
                <MenuItem value={'Senior Counsel'}>
                  {t('Senior Counsel')}
                </MenuItem>
                <MenuItem value={'Paralegal'}>{t('Paralegal')}</MenuItem>
                <MenuItem value={'Administrative Assistant'}>
                  {t('Administrative Assistant')}
                </MenuItem>
                {window.$brand === 'ZAP' && (
                  <MenuItem value='Gerente Zapotal'>Gerente Zapotal</MenuItem>
                )}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleEditClose}>{t('Cancel')}</Button>
            <Button onClick={() => this.update(this.state.edit)}>
              {t('Save')}
            </Button>
          </DialogActions>
        </Dialog>
      </ListItem>
    )
  }
}

export default withTranslation()(ADUserListItem)
